import React from 'react';
import { Route } from 'react-router-dom';
import { getOrigin, getFullUrl } from '@wkda/funnel-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function NotFoundRedirect() {
  return /*#__PURE__*/_jsx(Route, {
    component: Internal
  });
}
function Internal(_ref) {
  let {
    staticContext
  } = _ref;
  if (staticContext) staticContext.statusCode = 404;
  return /*#__PURE__*/_jsx("h1", {
    children: "404"
  });
}
NotFoundRedirect.getInitialProps = function name(_ref2) {
  let {
    req,
    appConfig
  } = _ref2;
  if (appConfig.env !== 'local') {
    const origin = getOrigin(req);
    const encodedUrl = encodeURIComponent(getFullUrl(req));
    return {
      redirectTo: `${origin}/not-found/?from=${encodedUrl}`,
      statusCode: 303
    };
  }
};